// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton_container__ISyQK","paddingContainer":"Skeleton_paddingContainer__bxuvI"};